module.exports = __webpack_public_path__ + "img/heart-icon.96a12711.svg";